function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 754 663",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4066.87,-2742.77)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3261.34,2146.93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-20,110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1031.47,887.632C1032.89,892.633 1034.51,897.593 1036.46,902.402C1040.95,913.511 1047.17,923.881 1057.86,930.834C1067.49,937.102 1080.42,940.428 1097.77,940.398C1197.9,940.226 1473.88,940.398 1473.88,940.398C1486.53,940.406 1496.79,950.681 1496.78,963.329C1496.77,975.977 1486.5,986.24 1473.85,986.232C1473.85,986.232 1197.95,986.06 1097.85,986.232C1069.46,986.28 1048.62,979.507 1032.86,969.25C997.933,946.523 987.727,904.306 979.938,868.472C965.056,800.007 928.346,609.272 922.883,581.655C918.207,558.02 912.864,544.383 903.954,537.385C898.746,533.296 892.491,532.38 885.647,531.909C874.455,531.14 862.003,532.103 848.444,532.103C835.796,532.103 825.527,521.834 825.527,509.186C825.527,496.538 835.796,486.269 848.444,486.269C863.148,486.269 876.652,485.35 888.789,486.184C905.278,487.317 919.715,491.486 932.262,501.339C944.289,510.784 955.189,526.237 963.006,552.81L1512.67,552.81C1541.95,552.81 1558.43,561.55 1567.72,572.685C1574.44,580.733 1578.19,590.717 1578.97,602.664C1579.74,614.635 1577.21,629.329 1572.9,645.851C1559.63,696.772 1547.2,743.545 1532.2,801.08C1522.79,837.145 1510.83,857.865 1493.27,870.416C1476.15,882.649 1452.39,887.632 1415.34,887.632L1031.47,887.632ZM972.896,598.643C983.795,654.691 1007.62,777.427 1021.12,841.799L1415.34,841.799C1439.48,841.799 1455.47,841.098 1466.62,833.126C1477.34,825.47 1482.11,811.513 1487.85,789.514C1502.85,731.982 1515.28,685.211 1528.55,634.291C1530.62,626.348 1532.31,619.02 1533,612.452C1533.44,608.228 1534.62,604.544 1532.54,602.051C1531.49,600.798 1529.59,600.523 1527.3,599.986C1523.29,599.044 1518.45,598.643 1512.67,598.643L972.896,598.643Z",
    style: {
      fill: "rgb(74,74,74)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3261.34,2146.93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.87382,0,0,0.87382,71.8294,196.453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1126.29,1055.3C1170.34,1055.3 1206.11,1091.06 1206.11,1135.11C1206.11,1179.16 1170.34,1214.93 1126.29,1214.93C1082.24,1214.93 1046.47,1179.16 1046.47,1135.11C1046.47,1091.06 1082.24,1055.3 1126.29,1055.3ZM1126.29,1106.8C1110.66,1106.8 1097.97,1119.49 1097.97,1135.11C1097.97,1150.74 1110.66,1163.43 1126.29,1163.43C1141.92,1163.43 1154.61,1150.74 1154.61,1135.11C1154.61,1119.49 1141.92,1106.8 1126.29,1106.8Z",
    style: {
      fill: "rgb(74,74,74)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3261.34,2146.93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.87382,0,0,0.87382,405.465,196.453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1126.29,1055.3C1170.34,1055.3 1206.11,1091.06 1206.11,1135.11C1206.11,1179.16 1170.34,1214.93 1126.29,1214.93C1082.24,1214.93 1046.47,1179.16 1046.47,1135.11C1046.47,1091.06 1082.24,1055.3 1126.29,1055.3ZM1126.29,1106.8C1110.66,1106.8 1097.97,1119.49 1097.97,1135.11C1097.97,1150.74 1110.66,1163.43 1126.29,1163.43C1141.92,1163.43 1154.61,1150.74 1154.61,1135.11C1154.61,1119.49 1141.92,1106.8 1126.29,1106.8Z",
    style: {
      fill: "rgb(74,74,74)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCartIcon);
export default __webpack_public_path__ + "static/media/newCartIcon.4ab7c51968bdd08747da0e8546428ba3.svg";
export { ForwardRef as ReactComponent };